import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon, CheckIcon } from "lucide-react";
import { routes } from "../../data/business";
import { heroChips } from "../../data/home";
import { images } from "../../data/images";
import { LiveCallCard } from "../LiveCallCard";
import { MagneticCallButton } from "../ui/MagneticCallButton";
export function HomeHero() {
  return <section aria-labelledby="hero-title" className="grain relative flex items-center overflow-hidden bg-navy text-white md:min-h-[min(88vh,860px)]" data-id="element-207" data-mp="2wudg4szzhfbe">
      {/* Full-bleed background layer behind all hero content */}
      <div className="absolute inset-0 z-0 overflow-hidden" aria-hidden="true" data-id="element-208" data-mp="2n3iqdenj3xl7">
        <img src={images.hero} alt="" fetchPriority="high" className="animate-kenburns h-full w-full object-cover" style={{
        objectPosition: "center 60%",
        filter: "brightness(1.15) saturate(1.1)"
      }} data-id="element-209" data-mp="2s2mxlzqw7l8w" />
        {/* Mobile: vertical overlay */}
        <div className="absolute inset-0 md:hidden" style={{
        background: "linear-gradient(180deg, rgba(15,30,51,0.55) 0%, rgba(15,30,51,0.92) 100%)"
      }} data-id="element-210" data-mp="oufs6pqk8ij8" />
        {/* Desktop: directional overlay so the city shows through on the right */}
        <div className="absolute inset-0 hidden md:block" style={{
        background: "linear-gradient(180deg, transparent 60%, rgba(15,30,51,0.85) 100%), linear-gradient(90deg, rgba(15,30,51,0.92) 0%, rgba(15,30,51,0.75) 45%, rgba(15,30,51,0.35) 100%)"
      }} data-id="element-211" data-mp="swu9v6ihtc8x" />
      </div>

      <div className="gutter relative z-[2] grid w-full items-center gap-[clamp(2rem,4vw,5rem)] pb-[clamp(3rem,5vw,4.5rem)] pt-[clamp(3rem,6vw,5rem)] lg:grid-cols-[1.25fr_0.75fr] ultra:grid-cols-[1.2fr_0.65fr_0.9fr]" data-id="element-212" data-mp="1gmoljkr2surl">
        <div className="flex flex-col" data-id="element-213" data-mp="3iejhms0umqop">
          <p className="eyebrow order-1 text-gold-soft" data-id="element-214" data-mp="3ifl55vz1x5nb">Las Vegas · Henderson · All of Clark County</p>
          <h1 id="hero-title" className="h1-fluid order-1 mt-4 max-w-[16ch] font-serif font-normal text-white" data-id="element-215" data-mp="3eej4daphklj8">
            Las Vegas Bail Bonds — Quick, <em className="font-light text-gold-soft" data-id="element-216" data-mp="1mboi55icgrn0">Courteous, Private</em> Bail. 24/7.
          </h1>
          <p className="measure order-3 mt-6 text-[clamp(1.05rem,1.2vw,1.35rem)] text-white/90 lg:order-2 lg:mt-7" data-id="element-217" data-mp="1r8ontfba7sdl">
            Someone you love is in jail. We'll help you get them home — with respect, total confidentiality, and a local, veteran-owned team that stays with you through the whole process.
          </p>
          <div className="order-2 mt-7 flex flex-col gap-4 sm:flex-row sm:items-center lg:order-3 lg:mt-9" data-id="element-218" data-mp="257wsuou4lupp">
            <MagneticCallButton size="xl" label="Call 702-384-7777 Now" data-id="element-219" data-mp="2a0zm0vuzr25d" />
            <Link to={routes.getBond} className="group inline-flex min-h-[48px] items-center gap-2 font-semibold text-white transition-colors duration-150 hover:text-gold-soft" data-id="element-220" data-mp="2ey9bucmalftq">
              Start Your Bail Bond Online
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-221" data-mp="ccdp5c8vj9su" />
            </Link>
          </div>
          <ul className="order-4 mt-7 grid gap-x-6 gap-y-3 text-[0.95rem] text-white sm:grid-cols-2 lg:mt-9 3xl:flex 3xl:flex-wrap" data-id="element-222" data-mp="8d4w69lnrfyc">
            {heroChips.map(c => <li key={c} className="flex items-center gap-2.5" data-id="element-223" data-mp="3ujju08psotb6">
                <CheckIcon className="h-4 w-4 shrink-0 text-gold-soft" strokeWidth={2} aria-hidden="true" data-id="element-224" data-mp="w14jt0noaq8p" />
                {c}
              </li>)}
          </ul>
        </div>

        <LiveCallCard data-id="element-225" data-mp="majr1tuokfxp" />
        <div className="hidden ultra:block" aria-hidden="true" data-id="element-226" data-mp="m9rsca5se237" />
      </div>
    </section>;
}